import { isFiniteNumber } from "./is-finite-number";

export const isFiniteZeroPositive = (value: any): value is number =>
  isFiniteNumber(value) && value >= 0;
